import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

class AttachmentImages extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentPreview: null,
    };
  }

  render() {
    const { images } = this.props;
    const { currentPreview } = this.state;

    return [
      images.map(image => [
        <hr key={`attachment-image-${image.fileId}-hr`} />,
        <div key={`attachment-image-${image.fileId}`}>
          <img
            role="presentation"
            eb-test="ee_notificationDetail_img_attachment"
            title={image.fileName}
            alt={image.fileName}
            className="img-fluid"
            src={`/download/image/${image.fileId}`}
            onClick={() => this.setState({ currentPreview: image })}
          />
        </div>,
      ]),
      currentPreview && (
        <Modal
          key="attachment-image-preview"
          className="preview-image"
          isOpen={!!currentPreview}
          onClosed={() => this.setState({ currentPreview: null })}
        >
          <ModalHeader toggle={() => this.setState({ currentPreview: null })}>
            {currentPreview.fileName}
          </ModalHeader>
          <ModalBody>
            <img
              alt={currentPreview.fileName}
              src={`/download/image/${currentPreview.fileId}`}
              className="img-fluid"
            />
          </ModalBody>
        </Modal>
      ),
    ];
  }
}

AttachmentImages.propTypes = {
  images: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default AttachmentImages;
